import { boolean, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import { defaultColumns } from './defaultColumns';
import { locationTable } from './location.sql';
import { relations } from 'drizzle-orm';

export const organisationTable = pgTable('organisation', {
  id: uuid('id').primaryKey().defaultRandom(),
  name: text('name').notNull(),
  deleted: boolean('deleted').notNull().default(false),
  deletedAt: timestamp('deletedAt'),
  thirdParty: boolean('thirdParty').notNull().default(false),
  ...defaultColumns,
});

export const organisationRelations = relations(
  organisationTable,
  ({ many }) => ({
    locations: many(locationTable),
  }),
);
